import type { InputHTMLAttributes } from 'react';

import React from 'react';

import { classNames } from '../../utils/class-names';

import styles from './checkbox.module.css';

export type CheckboxProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * @param {ReactNode} [children] Text to be displayed next to the element.
 * @default undefined
 */
export function Checkbox({ className, style, children, ...props }: CheckboxProps) {
  return (
    <label className={classNames(styles.checkbox, props.disabled && styles.disabled, className)} style={style}>
      <input type="checkbox" className={styles.input} {...props} />

      <svg width="12" height="12" viewBox="0 0 12 12" className={styles.icon}>
        <path
          className={styles.background}
          fillRule="evenodd"
          d="M12 0H0v12h12V0Zm-1.72 3.28a.75.75 0 1 0-1.06-1.06L4.25 7.19 2.28 5.22a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5Z"
        />

        <path
          className={styles.checkmark}
          d="M10.28 2.22c.3.3.3.77 0 1.06l-5.5 5.5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.97 1.97 4.97-4.97c.3-.3.77-.3 1.06 0Z"
        />
      </svg>

      {children}
    </label>
  );
}
